import React, { useContext, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { Button, Card, Col, ConfigProvider, List, Row, Typography } from 'antd';
import {
  LogoutOutlined,
  CreditCardOutlined,
  GiftOutlined
} from '@ant-design/icons';
import Barcode from 'react-barcode';

import { ApiCallGet } from '../../helpers/ApiCallGet';
import { API_PATH } from '../../helpers/Constants';
import { Context } from '../../context';

import { getStoredLanguage, translations } from '../../helpers/i18n';
import XerjoffConfigProvider from './XerjoffConfigProvider';
import XerjoffLogo from './XerjoffLogo';

const { Title, Text } = Typography;

function XerjoffSmartCard(props) {

  const [userAmounts, setUserAmounts] = useState([]);

  const [customerData, setCustomerData] = useState({});
  const [customerCard, setCustomerCard] = useState({});
  const [userData, setUserData] = useState({});
  const [render, setRender] = useState(false);

  const {reference, cardPage, language, appToken} = useContext(Context);
  const navigate = useNavigate();

    const t = translations[language] || translations[getStoredLanguage()];

  useEffect(()=>{
    
    if(!localStorage.getItem(reference)){
      navigate("/");
    }else{
        setUserData(JSON.parse(localStorage.getItem(reference)));
        setCustomerData(JSON.parse(localStorage.getItem(reference)).apps_customers);
        setCustomerCard(JSON.parse(localStorage.getItem(reference)).apps_customers_cards[0]);
  
        setRender(true);
    }

  }, [])

  useEffect(()=>{
    let customerCardCode = customerCard.ean13;

    if (!customerCardCode) {
      return
    } else {
      
      try {
        (async () => {
          const res = await ApiCallGet(`${API_PATH.EASYPOS}/get_customer.php?token_key=${appToken}&search=${customerCardCode}`);
    
          if (!res.status) {
            setUserAmounts(res[0]?.amounts);
          } else {
            console.log(res)
          }
        })()
      } catch (error) {
        console.log(error)
      }
    }

  }, [customerCard])
  
  const logout = () => {
    localStorage.removeItem(reference);
    navigate(`/?app=${reference}&password=false`)
  }
  return (
    <XerjoffConfigProvider>
    {render &&
      <section className='w-100 flex align-center justify-center'>
        
        <div className='xerjoff xerjoff-card-container w-100 p-10 mt-20'>
          
         <Row align={'center'} justify={'center'}>
           <Col span={24} align={'center'}>
              <XerjoffLogo />
              
              <div 
                className='card-wrapper w-100 flex column'
                style={{marginTop:!cardPage.media && "0px"}}
              >
                <div className='card-header fs-18 bold w-100 flex space-between'>
                  <Row align={"center"} className='w-100' gutter={[15,15]}>
                    <Col span={12} className='ant-sm-col-24'>
                      <div className='px-10 border-1 radius-1 p-10'>{customerData.name + " " + customerData.surname}</div>
                    </Col>
    
                    <Col span={12} align="end" className='ant-sm-col-24 sm-text-start'>
                      <div className='card-ecn w-100'>
                        <div className='px-10 border-1 radius-1 p-10 text-end sm-text-start'> N° {customerCard.ecn}</div>
                      </div>
                    </Col>
    
                  </Row>
                </div>
                <div className='card-code-wrapper bg-white p-10 mt-20 border-radius radius-2 overflow-hidden'>
                  <Barcode value={customerCard.ean13}/>
                </div>
              </div>
           </Col>
          </Row>
          
          <Row className='w-100' align={'center'}>
            <Col xs={18} md={6}>
              <div className='p-10'>
                  <Button type='primary' block size='large' icon={<LogoutOutlined />} onClick={logout}>{t.logout}</Button>
              </div>
            </Col>
          </Row>

        </div>
      </section>
    }
    </XerjoffConfigProvider>
  );
}

export default XerjoffSmartCard;